export const arqueoSvg = (
  <svg
    width="94"
    height="94"
    viewBox="0 0 94 94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1041_386)">
      <path
        d="M46.61 92.6401C72.0317 92.6401 92.64 72.0317 92.64 46.6101C92.64 21.1884 72.0317 0.580078 46.61 0.580078C21.1883 0.580078 0.580002 21.1884 0.580002 46.6101C0.580002 72.0317 21.1883 92.6401 46.61 92.6401Z"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.18 65.4003C57.6955 65.4003 66.22 56.8758 66.22 46.3603C66.22 35.8448 57.6955 27.3203 47.18 27.3203C36.6645 27.3203 28.14 35.8448 28.14 46.3603C28.14 56.8758 36.6645 65.4003 47.18 65.4003Z"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.34 32.5995L69.92 26.2695L75.77 33.9896L64.49 38.4296C64.49 38.4296 62.48 34.3595 60.34 32.5995Z"
        fill="white"
      />
      <path
        d="M28.93 41.5297C28.93 41.5297 30.14 35.7897 33.61 32.9997L26.1 30.4297L20.96 38.4297L28.93 41.5297Z"
        fill="white"
      />
      <path
        d="M47.18 65.4004L51.66 74.6304L60.9 70.9404L56.98 62.6904C54.0255 64.4796 50.634 65.4175 47.18 65.4004Z"
        fill="white"
      />
      <path
        d="M59.22 31.6097L71.14 21.2598C71.14 21.2598 88.84 43.5997 72.62 68.3897L82.62 75.2397"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.62 30.4299L72.47 17.1699C72.47 17.1699 84.27 29.7299 82.62 54.3699L91.25 57.7499"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.29 40.4495L77.67 34.5195"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.81 42.4102L75.81 38.4102C75.81 38.4102 78.49 55.0901 69.96 68.6401L81.07 77.1501"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.99 56.8301L90.49 60.5501"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.21 61.8799L64.06 73.3599C64.06 73.3599 41.6 88.3599 16.14 61.8799L5.19 66.7299"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.94 63.8904L17.22 58.6904C17.22 58.6904 29.55 72.9104 47.22 74.6304L45.07 65.2804"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.34 60.1204C60.64 59.8304 66.92 74.6304 66.92 74.6304C66.92 74.6304 48.46 89.4504 24.45 72.8304L16.24 81.2004"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.73 78.8105L24.45 69.2305"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.81001 69.7299C6.72001 69.5499 15.48 65.3799 15.48 65.3799L20.96 70.6299L12.58 77.6299C12.58 77.6299 7.62001 71.2199 6.81001 69.7299Z"
        fill="white"
      />
      <path
        d="M28.31 43.7997C28.31 43.7997 19.26 41.2297 19.09 41.2297C18.92 41.2297 23.09 18.8897 52.35 11.1097L55.22 1.38965"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.21 2.05957L54.04 13.8796C54.04 13.8796 38.17 17.5695 30.25 26.2695L35.95 30.9796"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.28 32.3503L26.02 27.3203"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.1 1.79004L41.58 15.08"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.62 2.4502L37.96 12.9102C26.8516 19.7677 18.7003 30.522 15.1 43.0703L28.1 46.3602"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.84 1.23959L42.34 11.3296L51.22 9.56961L52.72 1.23959C52.72 1.23959 47.46 -0.490408 38.84 1.23959Z"
        fill="white"
      />
      <path
        d="M84.04 73.4095L74.83 67.6896L79.44 59.3096L89.85 62.4296C89.85 62.4296 86.07 70.7795 84.04 73.4095Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1041_386">
        <rect width="93.22" height="93.22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const arqueoCollectionSvg = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 94 94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1041_386)">
      <path
        d="M46.61 92.6401C72.0317 92.6401 92.64 72.0317 92.64 46.6101C92.64 21.1884 72.0317 0.580078 46.61 0.580078C21.1883 0.580078 0.580002 21.1884 0.580002 46.6101C0.580002 72.0317 21.1883 92.6401 46.61 92.6401Z"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.18 65.4003C57.6955 65.4003 66.22 56.8758 66.22 46.3603C66.22 35.8448 57.6955 27.3203 47.18 27.3203C36.6645 27.3203 28.14 35.8448 28.14 46.3603C28.14 56.8758 36.6645 65.4003 47.18 65.4003Z"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.34 32.5995L69.92 26.2695L75.77 33.9896L64.49 38.4296C64.49 38.4296 62.48 34.3595 60.34 32.5995Z"
        fill="white"
      />
      <path
        d="M28.93 41.5297C28.93 41.5297 30.14 35.7897 33.61 32.9997L26.1 30.4297L20.96 38.4297L28.93 41.5297Z"
        fill="white"
      />
      <path
        d="M47.18 65.4004L51.66 74.6304L60.9 70.9404L56.98 62.6904C54.0255 64.4796 50.634 65.4175 47.18 65.4004Z"
        fill="white"
      />
      <path
        d="M59.22 31.6097L71.14 21.2598C71.14 21.2598 88.84 43.5997 72.62 68.3897L82.62 75.2397"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.62 30.4299L72.47 17.1699C72.47 17.1699 84.27 29.7299 82.62 54.3699L91.25 57.7499"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.29 40.4495L77.67 34.5195"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.81 42.4102L75.81 38.4102C75.81 38.4102 78.49 55.0901 69.96 68.6401L81.07 77.1501"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.99 56.8301L90.49 60.5501"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.21 61.8799L64.06 73.3599C64.06 73.3599 41.6 88.3599 16.14 61.8799L5.19 66.7299"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.94 63.8904L17.22 58.6904C17.22 58.6904 29.55 72.9104 47.22 74.6304L45.07 65.2804"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.34 60.1204C60.64 59.8304 66.92 74.6304 66.92 74.6304C66.92 74.6304 48.46 89.4504 24.45 72.8304L16.24 81.2004"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.73 78.8105L24.45 69.2305"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.81001 69.7299C6.72001 69.5499 15.48 65.3799 15.48 65.3799L20.96 70.6299L12.58 77.6299C12.58 77.6299 7.62001 71.2199 6.81001 69.7299Z"
        fill="white"
      />
      <path
        d="M28.31 43.7997C28.31 43.7997 19.26 41.2297 19.09 41.2297C18.92 41.2297 23.09 18.8897 52.35 11.1097L55.22 1.38965"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.21 2.05957L54.04 13.8796C54.04 13.8796 38.17 17.5695 30.25 26.2695L35.95 30.9796"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.28 32.3503L26.02 27.3203"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.1 1.79004L41.58 15.08"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.62 2.4502L37.96 12.9102C26.8516 19.7677 18.7003 30.522 15.1 43.0703L28.1 46.3602"
        stroke="white"
        strokeWidth="1.17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.84 1.23959L42.34 11.3296L51.22 9.56961L52.72 1.23959C52.72 1.23959 47.46 -0.490408 38.84 1.23959Z"
        fill="white"
      />
      <path
        d="M84.04 73.4095L74.83 67.6896L79.44 59.3096L89.85 62.4296C89.85 62.4296 86.07 70.7795 84.04 73.4095Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1041_386">
        <rect width="93.22" height="93.22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const bioSvg = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1041_409)">
      <path
        d="M18.7045 56.33L0.08066 56.1816L0.132509 55.1452C0.336166 51.1882 0.75177 47.2457 1.37738 43.3359L1.53589 42.3589L19.9119 45.3818L22.5889 45.8242C23.0165 45.895 23.4264 46.0519 23.7952 46.2859C24.164 46.5199 24.4844 46.8265 24.7382 47.1881C24.992 47.5498 25.1742 47.9593 25.2744 48.3935C25.3746 48.8277 25.3908 49.278 25.3221 49.7186C25.2534 50.1593 25.1012 50.5817 24.8741 50.9617C24.647 51.3417 24.3495 51.6719 23.9986 51.9334C23.6476 52.195 23.2501 52.3827 22.8288 52.486C22.4074 52.5892 21.9705 52.6059 21.5429 52.5351L19.0157 52.1194C18.9091 53.2151 18.8255 54.3078 18.7593 55.3857L18.7045 56.33ZM2.11509 54.2099L16.8977 54.3287C16.9784 53.1854 17.3185 49.8389 17.3185 49.8389L21.8512 50.5842C22.0308 50.6203 22.2158 50.6176 22.3943 50.5763C22.5729 50.5351 22.7412 50.4562 22.8888 50.3446C23.0363 50.2331 23.1598 50.0912 23.2515 49.928C23.3432 49.7648 23.4012 49.5839 23.4217 49.3965C23.4782 49.0264 23.3901 48.6484 23.1768 48.3451C22.9635 48.0418 22.6423 47.8379 22.2835 47.7781L17.6901 47.0239L3.12654 44.6276C2.64531 47.8316 2.30528 51.0445 2.11509 54.2099ZM20.3038 43.2795L1.91621 40.2506L2.11798 39.2351C2.76346 35.9955 3.60775 32.4708 4.62496 28.7531L4.87562 27.8266L25.1535 33.0172C25.9348 33.2179 26.6179 33.7061 27.0741 34.3898C27.5304 35.0735 27.7283 35.9055 27.6305 36.7291C27.5327 37.5527 27.146 38.311 26.5433 38.8612C25.9405 39.4114 25.1634 39.7155 24.3582 39.7162C24.0901 39.7165 23.8229 39.6825 23.5629 39.6152L21.2374 39.0213C20.9665 40.1616 20.7187 41.281 20.4968 42.3589L20.3038 43.2795ZM4.21284 38.6204L18.8053 41.0227C19.0474 39.9032 19.8341 36.6161 19.8341 36.6161L24.0268 37.688C24.2016 37.7329 24.3833 37.7418 24.5615 37.7143C24.7397 37.6868 24.9108 37.6234 25.0652 37.5277C25.2196 37.432 25.3542 37.3059 25.4613 37.1567C25.5684 37.0074 25.6459 36.8378 25.6895 36.6577C25.733 36.4775 25.7416 36.2903 25.7149 36.1067C25.6882 35.9231 25.6268 35.7467 25.5339 35.5876C25.4411 35.4285 25.3187 35.2898 25.1738 35.1794C25.0289 35.069 24.8644 34.9892 24.6896 34.9443L6.22715 30.22C5.43759 33.1686 4.76323 35.9836 4.21284 38.6204V38.6204ZM5.2589 89.9913L4.85839 89.1005C4.6365 88.6016 2.65103 83.999 1.28227 75.9697L1.118 75.0195L21.3844 70.702C22.2382 70.5291 23.1239 70.7098 23.8493 71.205C24.5748 71.7002 25.0816 72.4701 25.2601 73.3478C25.3482 73.7847 25.3517 74.2353 25.2706 74.6737C25.1895 75.1121 25.0252 75.5297 24.7873 75.9026C24.5493 76.2755 24.2423 76.5964 23.8839 76.8469C23.5254 77.0974 23.1226 77.2725 22.6984 77.3624L20.7187 77.787C21.1243 79.2457 21.6131 80.6785 22.1826 82.0778L5.2589 89.9913ZM3.34554 76.5636C3.98244 80.2432 4.94705 83.8544 6.22715 87.3515L19.6871 81.0504C19.4134 80.2665 18.3327 76.2548 18.3327 76.2548L22.2949 75.4085C22.4716 75.3717 22.6395 75.2993 22.7889 75.1954C22.9382 75.0914 23.0661 74.958 23.1652 74.8029C23.2644 74.6478 23.3327 74.4739 23.3663 74.2915C23.3999 74.109 23.3982 73.9215 23.3612 73.7397C23.2868 73.3763 23.077 73.0575 22.7768 72.852C22.4766 72.6465 22.11 72.5708 21.7561 72.641L3.34554 76.5636ZM0.809715 72.8934L0.680057 71.8274C0.182565 67.6717 -0.0427351 63.4863 0.00573538 59.2995V58.3077L21.7186 58.4829C22.5937 58.4864 23.4315 58.848 24.0479 59.4882C24.6642 60.1283 25.0085 60.9945 25.0051 61.8962C25.0016 62.7979 24.6508 63.6613 24.0296 64.2965C23.4084 64.9316 22.5678 65.2864 21.6927 65.2828L18.7506 65.259C18.8111 66.2093 18.8889 67.1625 18.9868 68.1038L19.0762 68.9946L0.809715 72.8934ZM1.92774 60.3091C1.9246 63.7177 2.10549 67.124 2.46952 70.512L16.9957 67.4148C16.9035 66.3815 16.7277 63.2577 16.7277 63.2577L21.6927 63.2963C22.0565 63.299 22.4064 63.1528 22.6655 62.8896C22.9247 62.6265 23.0717 62.2681 23.0744 61.8932C23.0771 61.5184 22.9352 61.1577 22.6798 60.8907C22.4245 60.6237 22.0767 60.4721 21.7129 60.4694L1.92774 60.3091ZM27.6144 17.9296L9.90978 11.9581L10.2556 10.993C12.3073 5.23233 13.9009 1.33052 14.0766 0.896989L14.4512 -0.0175781L32.9626 8.02065C33.7712 8.36559 34.4137 9.02739 34.7488 9.86047C35.0839 10.6936 35.084 11.6297 34.7493 12.4629C34.4146 13.2961 33.7723 13.9581 32.9638 14.3034C32.1554 14.6487 31.2469 14.6488 30.4383 14.3039L29.1359 13.7486C28.7671 14.7345 28.3636 15.8272 27.9371 17.015L27.6144 17.9296ZM12.4111 10.7109L26.4502 15.4471C26.8998 14.2059 28.0496 11.1415 28.0496 11.1415L31.1761 12.4748C31.4267 12.5819 31.7026 12.6099 31.9688 12.5554C32.2349 12.5009 32.4794 12.3662 32.6712 12.1685C32.8631 11.9708 32.9938 11.7189 33.0467 11.4446C33.0996 11.1704 33.0723 10.8861 32.9684 10.6278C32.8999 10.4557 32.7989 10.2994 32.6712 10.1679C32.5436 10.0364 32.392 9.93228 32.225 9.86167V9.86167L28.2944 8.18692L15.48 2.59552C14.918 4.0149 13.7885 6.8982 12.4111 10.7228V10.7109ZM23.5456 30.3892L5.4606 25.7629L5.74876 24.7622C6.6824 21.5938 7.73999 18.274 8.88975 14.8918L9.2038 13.9743L28.7353 20.5635C29.1519 20.6984 29.5382 20.9172 29.8721 21.2072C30.2059 21.4971 30.4806 21.8525 30.6802 22.2527C30.8798 22.6528 31.0003 23.0898 31.0348 23.5383C31.0693 23.9869 31.017 24.438 30.8811 24.8656C30.7451 25.2931 30.5282 25.6886 30.2428 26.0291C29.9575 26.3696 29.6093 26.6484 29.2186 26.8492C28.8279 27.0501 28.4024 27.1691 27.9668 27.1992C27.5311 27.2294 27.094 27.1701 26.6808 27.0249L24.7702 26.3805C24.4475 27.398 24.1267 28.4354 23.8078 29.4925L23.5456 30.3892ZM7.89843 24.3405L22.246 28.0107C22.5745 26.9269 23.5456 23.8743 23.5456 23.8743L27.2917 25.1363C27.6357 25.2491 28.0088 25.2191 28.3317 25.0528C28.6546 24.8864 28.9018 24.5968 29.0206 24.2455C29.1324 23.891 29.1043 23.5055 28.9426 23.1722C28.7809 22.8388 28.4984 22.5844 28.1561 22.4638L24.3236 21.1722L10.4198 16.4835C9.50348 19.1649 8.66205 21.8047 7.89843 24.3524V24.3405Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1041_409">
        <rect width="35" height="90" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const bioCollectionSvg = (
  <svg
    width="35"
    height="55"
    viewBox="0 0 35 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1041_409)">
      <path
        d="M18.7045 56.33L0.08066 56.1816L0.132509 55.1452C0.336166 51.1882 0.75177 47.2457 1.37738 43.3359L1.53589 42.3589L19.9119 45.3818L22.5889 45.8242C23.0165 45.895 23.4264 46.0519 23.7952 46.2859C24.164 46.5199 24.4844 46.8265 24.7382 47.1881C24.992 47.5498 25.1742 47.9593 25.2744 48.3935C25.3746 48.8277 25.3908 49.278 25.3221 49.7186C25.2534 50.1593 25.1012 50.5817 24.8741 50.9617C24.647 51.3417 24.3495 51.6719 23.9986 51.9334C23.6476 52.195 23.2501 52.3827 22.8288 52.486C22.4074 52.5892 21.9705 52.6059 21.5429 52.5351L19.0157 52.1194C18.9091 53.2151 18.8255 54.3078 18.7593 55.3857L18.7045 56.33ZM2.11509 54.2099L16.8977 54.3287C16.9784 53.1854 17.3185 49.8389 17.3185 49.8389L21.8512 50.5842C22.0308 50.6203 22.2158 50.6176 22.3943 50.5763C22.5729 50.5351 22.7412 50.4562 22.8888 50.3446C23.0363 50.2331 23.1598 50.0912 23.2515 49.928C23.3432 49.7648 23.4012 49.5839 23.4217 49.3965C23.4782 49.0264 23.3901 48.6484 23.1768 48.3451C22.9635 48.0418 22.6423 47.8379 22.2835 47.7781L17.6901 47.0239L3.12654 44.6276C2.64531 47.8316 2.30528 51.0445 2.11509 54.2099ZM20.3038 43.2795L1.91621 40.2506L2.11798 39.2351C2.76346 35.9955 3.60775 32.4708 4.62496 28.7531L4.87562 27.8266L25.1535 33.0172C25.9348 33.2179 26.6179 33.7061 27.0741 34.3898C27.5304 35.0735 27.7283 35.9055 27.6305 36.7291C27.5327 37.5527 27.146 38.311 26.5433 38.8612C25.9405 39.4114 25.1634 39.7155 24.3582 39.7162C24.0901 39.7165 23.8229 39.6825 23.5629 39.6152L21.2374 39.0213C20.9665 40.1616 20.7187 41.281 20.4968 42.3589L20.3038 43.2795ZM4.21284 38.6204L18.8053 41.0227C19.0474 39.9032 19.8341 36.6161 19.8341 36.6161L24.0268 37.688C24.2016 37.7329 24.3833 37.7418 24.5615 37.7143C24.7397 37.6868 24.9108 37.6234 25.0652 37.5277C25.2196 37.432 25.3542 37.3059 25.4613 37.1567C25.5684 37.0074 25.6459 36.8378 25.6895 36.6577C25.733 36.4775 25.7416 36.2903 25.7149 36.1067C25.6882 35.9231 25.6268 35.7467 25.5339 35.5876C25.4411 35.4285 25.3187 35.2898 25.1738 35.1794C25.0289 35.069 24.8644 34.9892 24.6896 34.9443L6.22715 30.22C5.43759 33.1686 4.76323 35.9836 4.21284 38.6204V38.6204ZM5.2589 89.9913L4.85839 89.1005C4.6365 88.6016 2.65103 83.999 1.28227 75.9697L1.118 75.0195L21.3844 70.702C22.2382 70.5291 23.1239 70.7098 23.8493 71.205C24.5748 71.7002 25.0816 72.4701 25.2601 73.3478C25.3482 73.7847 25.3517 74.2353 25.2706 74.6737C25.1895 75.1121 25.0252 75.5297 24.7873 75.9026C24.5493 76.2755 24.2423 76.5964 23.8839 76.8469C23.5254 77.0974 23.1226 77.2725 22.6984 77.3624L20.7187 77.787C21.1243 79.2457 21.6131 80.6785 22.1826 82.0778L5.2589 89.9913ZM3.34554 76.5636C3.98244 80.2432 4.94705 83.8544 6.22715 87.3515L19.6871 81.0504C19.4134 80.2665 18.3327 76.2548 18.3327 76.2548L22.2949 75.4085C22.4716 75.3717 22.6395 75.2993 22.7889 75.1954C22.9382 75.0914 23.0661 74.958 23.1652 74.8029C23.2644 74.6478 23.3327 74.4739 23.3663 74.2915C23.3999 74.109 23.3982 73.9215 23.3612 73.7397C23.2868 73.3763 23.077 73.0575 22.7768 72.852C22.4766 72.6465 22.11 72.5708 21.7561 72.641L3.34554 76.5636ZM0.809715 72.8934L0.680057 71.8274C0.182565 67.6717 -0.0427351 63.4863 0.00573538 59.2995V58.3077L21.7186 58.4829C22.5937 58.4864 23.4315 58.848 24.0479 59.4882C24.6642 60.1283 25.0085 60.9945 25.0051 61.8962C25.0016 62.7979 24.6508 63.6613 24.0296 64.2965C23.4084 64.9316 22.5678 65.2864 21.6927 65.2828L18.7506 65.259C18.8111 66.2093 18.8889 67.1625 18.9868 68.1038L19.0762 68.9946L0.809715 72.8934ZM1.92774 60.3091C1.9246 63.7177 2.10549 67.124 2.46952 70.512L16.9957 67.4148C16.9035 66.3815 16.7277 63.2577 16.7277 63.2577L21.6927 63.2963C22.0565 63.299 22.4064 63.1528 22.6655 62.8896C22.9247 62.6265 23.0717 62.2681 23.0744 61.8932C23.0771 61.5184 22.9352 61.1577 22.6798 60.8907C22.4245 60.6237 22.0767 60.4721 21.7129 60.4694L1.92774 60.3091ZM27.6144 17.9296L9.90978 11.9581L10.2556 10.993C12.3073 5.23233 13.9009 1.33052 14.0766 0.896989L14.4512 -0.0175781L32.9626 8.02065C33.7712 8.36559 34.4137 9.02739 34.7488 9.86047C35.0839 10.6936 35.084 11.6297 34.7493 12.4629C34.4146 13.2961 33.7723 13.9581 32.9638 14.3034C32.1554 14.6487 31.2469 14.6488 30.4383 14.3039L29.1359 13.7486C28.7671 14.7345 28.3636 15.8272 27.9371 17.015L27.6144 17.9296ZM12.4111 10.7109L26.4502 15.4471C26.8998 14.2059 28.0496 11.1415 28.0496 11.1415L31.1761 12.4748C31.4267 12.5819 31.7026 12.6099 31.9688 12.5554C32.2349 12.5009 32.4794 12.3662 32.6712 12.1685C32.8631 11.9708 32.9938 11.7189 33.0467 11.4446C33.0996 11.1704 33.0723 10.8861 32.9684 10.6278C32.8999 10.4557 32.7989 10.2994 32.6712 10.1679C32.5436 10.0364 32.392 9.93228 32.225 9.86167V9.86167L28.2944 8.18692L15.48 2.59552C14.918 4.0149 13.7885 6.8982 12.4111 10.7228V10.7109ZM23.5456 30.3892L5.4606 25.7629L5.74876 24.7622C6.6824 21.5938 7.73999 18.274 8.88975 14.8918L9.2038 13.9743L28.7353 20.5635C29.1519 20.6984 29.5382 20.9172 29.8721 21.2072C30.2059 21.4971 30.4806 21.8525 30.6802 22.2527C30.8798 22.6528 31.0003 23.0898 31.0348 23.5383C31.0693 23.9869 31.017 24.438 30.8811 24.8656C30.7451 25.2931 30.5282 25.6886 30.2428 26.0291C29.9575 26.3696 29.6093 26.6484 29.2186 26.8492C28.8279 27.0501 28.4024 27.1691 27.9668 27.1992C27.5311 27.2294 27.094 27.1701 26.6808 27.0249L24.7702 26.3805C24.4475 27.398 24.1267 28.4354 23.8078 29.4925L23.5456 30.3892ZM7.89843 24.3405L22.246 28.0107C22.5745 26.9269 23.5456 23.8743 23.5456 23.8743L27.2917 25.1363C27.6357 25.2491 28.0088 25.2191 28.3317 25.0528C28.6546 24.8864 28.9018 24.5968 29.0206 24.2455C29.1324 23.891 29.1043 23.5055 28.9426 23.1722C28.7809 22.8388 28.4984 22.5844 28.1561 22.4638L24.3236 21.1722L10.4198 16.4835C9.50348 19.1649 8.66205 21.8047 7.89843 24.3524V24.3405Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1041_409">
        <rect width="35" height="90" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const etnoSvg = (
  <svg
    width="82"
    height="30"
    viewBox="0 0 82 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41 0.522461C41 0.522461 11.038 0.522451 8.81351 13.8412C8.81351 13.8412 2.8043 19.0684 6.22008 24.7137C6.22008 24.7137 -0.590407 26.6373 0.685242 38.0116C0.685242 38.0116 1.65518 47.4205 7.88583 46.1764C8.36369 45.8296 8.76591 45.3906 9.06845 44.8858C9.371 44.381 9.5676 43.8208 9.64642 43.2388C9.64642 43.2388 8.13883 66.3323 14.127 71.5908C14.127 71.5908 21.1378 80.477 41 80.477"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.75468 40.5C5.98904 40.5 6.9897 39.5077 6.9897 38.2837C6.9897 37.0597 5.98904 36.0674 4.75468 36.0674C3.52031 36.0674 2.51965 37.0597 2.51965 38.2837C2.51965 39.5077 3.52031 40.5 4.75468 40.5Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.8426 38.2833C27.0261 38.2833 32.0388 34.3937 32.0388 29.5957C32.0388 24.7977 27.0261 20.9082 20.8426 20.9082C14.6591 20.9082 9.64642 24.7977 9.64642 29.5957C9.64642 34.3937 14.6591 38.2833 20.8426 38.2833Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5952 27.171C17.5581 26.1566 24.6332 26.1566 31.596 27.171"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.64642 29.596C9.64642 29.596 22.2975 27.5783 32.0388 29.596"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1013 13.8413C11.5546 13.8413 36.2242 11.0604 39.8614 17.5107V38.273C39.8614 38.273 36.0766 38.4194 35.7709 40.4998"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41 0.522461C41 0.522461 70.9619 0.522461 73.1864 13.8517C73.1864 13.8517 79.2062 19.0789 75.7799 24.7137C75.7799 24.7137 82.5904 26.6478 81.3147 38.0116C81.3147 38.0116 80.3448 47.4205 74.1141 46.1764C73.6363 45.8296 73.2341 45.3906 72.9315 44.8858C72.629 44.381 72.4324 43.8208 72.3536 43.2388C72.3536 43.2388 73.8717 66.3323 67.8835 71.5908C67.8835 71.5908 60.8622 80.477 41 80.477"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.2453 40.5C78.4797 40.5 79.4804 39.5077 79.4804 38.2837C79.4804 37.0597 78.4797 36.0674 77.2453 36.0674C76.011 36.0674 75.0103 37.0597 75.0103 38.2837C75.0103 39.5077 76.011 40.5 77.2453 40.5Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.1574 38.2833C67.3409 38.2833 72.3536 34.3937 72.3536 29.5957C72.3536 24.7977 67.3409 20.9082 61.1574 20.9082C54.9739 20.9082 49.9612 24.7977 49.9612 29.5957C49.9612 34.3937 54.9739 38.2833 61.1574 38.2833Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M71.4047 27.171C64.4419 26.1566 57.3668 26.1566 50.4039 27.171"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M72.3536 29.596C72.3536 29.596 59.7025 27.5783 49.9612 29.596"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.8987 13.8518C70.4453 13.8518 45.7758 11.0605 42.1386 17.5108V38.2835C42.1386 38.2835 45.9234 38.4299 46.2291 40.4998"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.9612 57.7395C49.9612 60.489 46.4505 62.7053 42.107 62.7053C37.7634 62.7053 34.2633 60.489 34.2633 57.7395C34.2634 57.4023 34.3168 57.0672 34.4215 56.7463C35.1489 54.4778 38.3116 52.7842 42.107 52.7842C46.4505 52.7842 49.9612 55.0005 49.9612 57.7395Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.6534 56.1924H49.5606"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.2633 57.75H49.9612"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const etnoCollectionSvg = (
  <svg
    width="82"
    height="55"
    viewBox="0 0 82 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41 0.522461C41 0.522461 11.038 0.522451 8.81351 13.8412C8.81351 13.8412 2.8043 19.0684 6.22008 24.7137C6.22008 24.7137 -0.590407 26.6373 0.685242 38.0116C0.685242 38.0116 1.65518 47.4205 7.88583 46.1764C8.36369 45.8296 8.76591 45.3906 9.06845 44.8858C9.371 44.381 9.5676 43.8208 9.64642 43.2388C9.64642 43.2388 8.13883 66.3323 14.127 71.5908C14.127 71.5908 21.1378 80.477 41 80.477"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.75468 40.5C5.98904 40.5 6.9897 39.5077 6.9897 38.2837C6.9897 37.0597 5.98904 36.0674 4.75468 36.0674C3.52031 36.0674 2.51965 37.0597 2.51965 38.2837C2.51965 39.5077 3.52031 40.5 4.75468 40.5Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.8426 38.2833C27.0261 38.2833 32.0388 34.3937 32.0388 29.5957C32.0388 24.7977 27.0261 20.9082 20.8426 20.9082C14.6591 20.9082 9.64642 24.7977 9.64642 29.5957C9.64642 34.3937 14.6591 38.2833 20.8426 38.2833Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5952 27.171C17.5581 26.1566 24.6332 26.1566 31.596 27.171"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.64642 29.596C9.64642 29.596 22.2975 27.5783 32.0388 29.596"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1013 13.8413C11.5546 13.8413 36.2242 11.0604 39.8614 17.5107V38.273C39.8614 38.273 36.0766 38.4194 35.7709 40.4998"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41 0.522461C41 0.522461 70.9619 0.522461 73.1864 13.8517C73.1864 13.8517 79.2062 19.0789 75.7799 24.7137C75.7799 24.7137 82.5904 26.6478 81.3147 38.0116C81.3147 38.0116 80.3448 47.4205 74.1141 46.1764C73.6363 45.8296 73.2341 45.3906 72.9315 44.8858C72.629 44.381 72.4324 43.8208 72.3536 43.2388C72.3536 43.2388 73.8717 66.3323 67.8835 71.5908C67.8835 71.5908 60.8622 80.477 41 80.477"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.2453 40.5C78.4797 40.5 79.4804 39.5077 79.4804 38.2837C79.4804 37.0597 78.4797 36.0674 77.2453 36.0674C76.011 36.0674 75.0103 37.0597 75.0103 38.2837C75.0103 39.5077 76.011 40.5 77.2453 40.5Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.1574 38.2833C67.3409 38.2833 72.3536 34.3937 72.3536 29.5957C72.3536 24.7977 67.3409 20.9082 61.1574 20.9082C54.9739 20.9082 49.9612 24.7977 49.9612 29.5957C49.9612 34.3937 54.9739 38.2833 61.1574 38.2833Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M71.4047 27.171C64.4419 26.1566 57.3668 26.1566 50.4039 27.171"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M72.3536 29.596C72.3536 29.596 59.7025 27.5783 49.9612 29.596"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.8987 13.8518C70.4453 13.8518 45.7758 11.0605 42.1386 17.5108V38.2835C42.1386 38.2835 45.9234 38.4299 46.2291 40.4998"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.9612 57.7395C49.9612 60.489 46.4505 62.7053 42.107 62.7053C37.7634 62.7053 34.2633 60.489 34.2633 57.7395C34.2634 57.4023 34.3168 57.0672 34.4215 56.7463C35.1489 54.4778 38.3116 52.7842 42.107 52.7842C46.4505 52.7842 49.9612 55.0005 49.9612 57.7395Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.6534 56.1924H49.5606"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.2633 57.75H49.9612"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const histoSvg = (
  <svg
    width="78"
    height="25"
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1041_411)">
      <path
        d="M77.9242 14.574C77.8182 10.8546 77.7121 6.64946 75.2121 3.68916C74.35 2.6483 73.278 1.80186 72.0664 1.20534C70.8548 0.608822 69.5309 0.275709 68.1818 0.227896C67.803 0.227896 67.4091 0.227896 66.9848 0.227896C62.303 0.0457239 57.5909 -0.0605469 52.9394 -0.0605469C46.4394 -0.0605469 39.8636 0.136814 33.4242 0.516339C28.4394 0.804778 22.5455 1.1843 16.6364 1.83708H16.2727C13.5606 2.12552 10.4848 2.45951 8.69696 4.69111C6.57575 7.33261 6.81817 11.2493 7.01514 14.5436C7.36057 19.2658 7.94212 23.9677 8.75758 28.6315C9.19697 31.2427 9.66665 33.8538 10.1364 36.4649C11.8142 44.6134 12.8979 52.8735 13.3788 61.1796L10.0151 61.2556C9.48483 61.2556 8.83333 61.2555 8.10605 61.1493C7.37878 61.043 6.19697 60.9975 5.22727 60.9975C2.74243 60.9975 1.28788 61.5136 0.68182 62.6522C-0.575756 64.9293 0.106052 69.9087 1.1212 72.201C3.33332 77.2563 8.96968 77.8939 13.6363 77.8939C14.9545 77.8939 16.2576 77.8939 17.4848 77.8028C18.7121 77.7118 19.5455 77.7118 20.5151 77.7118H23.7727C33.4394 77.7118 43.4697 77.7117 53.2424 76.6946C53.3209 76.6941 53.3984 76.6762 53.4691 76.642C53.5399 76.6079 53.6022 76.5584 53.6515 76.4973H53.9091C54.5221 76.4951 55.1344 76.4545 55.7424 76.3758C60.5 75.7838 63.5606 73.9013 64.8333 70.7588C66.5455 66.4778 65.6818 61.377 64.9242 56.8834L64.697 55.5323C64.2525 52.8604 63.7727 50.1481 63.2576 47.3953C61.4848 37.725 59.6515 27.66 60.2273 17.9897H63.1364H67.6061C70.8578 18.0211 74.1079 17.8284 77.3333 17.4128C77.5282 17.3624 77.7009 17.2485 77.8243 17.0892C77.9477 16.9298 78.0148 16.734 78.0151 16.5323C77.9697 16.0161 77.9394 15.3027 77.9242 14.574ZM74.3939 16.0921C73.3968 16.2923 72.3802 16.3789 71.3636 16.3501H68.4091C66.8182 16.3501 65.2273 16.3501 63.6363 16.3501H60.3636C60.5152 14.832 60.697 13.4354 60.9242 12.2057C62.1515 5.48055 64.5758 2.06478 68.1212 2.06478C68.6317 2.06469 69.1404 2.12589 69.6364 2.247C73.5303 3.15786 75.697 6.43692 76.0454 12.2664C76.0454 12.6459 76.0455 13.0103 76.1515 13.3291C76.2879 14.8168 76.3939 15.6062 74.3939 16.1528V16.0921ZM2.0909 67.9959C1.90908 64.9597 2.87878 63.6238 5.71211 63.2139C7.51943 62.9663 9.34271 62.8547 11.1667 62.8799H14.197H17.2273H18.4394L43.6364 62.3637C43.7765 66.1429 44.9907 69.8033 47.1363 72.9146C47.6882 73.7784 48.3976 74.5303 49.2273 75.131C43.4394 75.5712 37.1818 75.7838 29.0455 75.8293H23.9848H16.9848H15.0909C14.2879 75.8293 13.4697 75.8293 12.6364 75.8293C10.0299 76.0241 7.4269 75.4092 5.18182 74.0683C4.24547 73.3666 3.48062 72.4607 2.94514 71.4193C2.40965 70.3778 2.11754 69.2279 2.0909 68.0566V67.9959ZM45.4394 61.5136C45.4679 61.3397 45.4351 61.1613 45.3466 61.0089C45.2582 60.8566 45.1195 60.7398 44.9545 60.6787C44.8261 60.6197 44.6867 60.5887 44.5455 60.5876L15.2121 61.1948C14.7255 52.7612 13.6267 44.3743 11.9242 36.1006V35.6604C11.0909 31.1061 10.2273 26.3544 9.6212 21.6483C9.5303 20.9652 9.40908 20.1302 9.28787 19.356C8.66666 15.4241 7.89393 10.5358 9.28787 7.46926C11.0909 3.65883 16.197 3.43107 20.2879 3.2489C21.106 3.2489 21.8939 3.24891 22.6212 3.11228C27.7121 2.68721 32.4091 2.36843 36.9848 2.14072C42.0303 1.89782 47.2424 1.77639 52.4697 1.77639C56.0606 1.77639 59.7576 1.77637 63.4545 1.94336C60.5757 4.41786 59.5757 8.71408 58.9091 12.9951C58.1017 19.1705 58.1425 25.4276 59.0303 31.5919C59.5909 36.1462 60.3333 40.7005 61.0606 45.1485C61.303 46.6666 61.5606 48.1847 61.803 49.7028C62 50.9932 62.2424 52.2836 62.4697 53.5891C63.289 57.3979 63.7406 61.2768 63.8182 65.1722C63.8182 69.8176 62.303 72.4591 59.0758 73.7039C57.3664 74.387 55.5515 74.7672 53.7121 74.8274C52.8483 74.8444 51.9893 74.6949 51.1818 74.3871C47.4546 72.9905 45.0151 65.491 45.4394 61.5743V61.5136Z"
        fill="white"
      />
      <path
        d="M48.7424 13.9058C48.7408 13.7967 48.7167 13.6892 48.6715 13.5899C48.6264 13.4906 48.5611 13.4018 48.48 13.329C48.3988 13.2563 48.3035 13.2012 48.2 13.1672C48.0966 13.1332 47.9872 13.1211 47.8788 13.1316C37.803 14.1184 27.5606 14.6497 17.4545 14.6497C17.3353 14.6476 17.2168 14.6698 17.1064 14.715C16.996 14.7602 16.8959 14.8275 16.8123 14.9127C16.7286 14.9979 16.6632 15.0993 16.6199 15.2107C16.5767 15.3221 16.5565 15.4411 16.5606 15.5606C16.5543 15.6793 16.5726 15.798 16.6141 15.9093C16.6557 16.0207 16.7196 16.1222 16.8021 16.2077C16.8845 16.2931 16.9837 16.3606 17.0933 16.406C17.203 16.4514 17.3208 16.4737 17.4394 16.4714C27.5606 16.4714 37.803 15.9705 47.8939 14.9533C48.1448 14.9265 48.3749 14.8013 48.5339 14.605C48.6929 14.4087 48.7679 14.1573 48.7424 13.9058Z"
        fill="white"
      />
      <path
        d="M48.2121 25.6258C48.2184 25.5071 48.2002 25.3883 48.1586 25.277C48.1171 25.1657 48.0531 25.0641 47.9706 24.9786C47.8882 24.8932 47.789 24.8256 47.6794 24.7803C47.5697 24.7349 47.4519 24.7126 47.3333 24.7149C37.8366 24.6431 28.3501 25.354 18.9697 26.8402C18.7671 26.8631 18.5817 26.9654 18.454 27.1246C18.3263 27.2838 18.2666 27.4872 18.2879 27.6904C18.3065 27.9376 18.416 28.1691 18.5951 28.3401C18.7742 28.5112 19.0102 28.6096 19.2576 28.6164H19.4242C28.6555 27.1667 37.9897 26.4762 47.3333 26.5518C47.4533 26.5542 47.5724 26.5316 47.6832 26.4853C47.7939 26.439 47.8938 26.37 47.9765 26.2829C48.0592 26.1958 48.1228 26.0924 48.1634 25.9792C48.204 25.8661 48.2206 25.7457 48.2121 25.6258Z"
        fill="white"
      />
      <path
        d="M20.5758 39.896H20.7727C25.2911 39.2437 29.8451 38.8686 34.4091 38.7726H36.1364C37.3939 38.7726 38.6515 38.9396 39.8788 39.0611C41.3878 39.2393 42.9049 39.3406 44.4242 39.3647C46.0459 39.3874 47.6612 39.1569 49.2121 38.6815C49.4194 38.615 49.5953 38.475 49.7069 38.2877C49.8185 38.1004 49.8581 37.8788 49.8182 37.6644C49.7998 37.4575 49.7064 37.2644 49.5556 37.1218C49.4049 36.9791 49.2072 36.8967 49 36.8901C48.9046 36.8756 48.8075 36.8756 48.7121 36.8901C47.2374 37.3298 45.7052 37.5447 44.1667 37.5278C42.6515 37.5278 40.9848 37.3608 39.4242 37.209C37.8636 37.0572 36.3939 36.8902 34.8788 36.875H34.4849C29.9209 36.9734 25.3672 37.3485 20.8485 37.9984C20.5951 38.0325 20.3649 38.1641 20.2065 38.3653C20.0482 38.5664 19.9741 38.8213 20 39.0762C19.9802 39.2596 20.0277 39.444 20.1336 39.5949C20.2396 39.7457 20.3967 39.8528 20.5758 39.896Z"
        fill="white"
      />
      <path
        d="M49.3939 48.7764C46.2424 48.913 43.0303 48.9737 39.9394 49.0344C33.543 49.0395 27.151 49.3689 20.7879 50.0212C20.5373 50.0554 20.3095 50.1847 20.1516 50.3825C19.9936 50.5804 19.9176 50.8315 19.9394 51.0839C19.9394 51.2892 20.0208 51.4861 20.1657 51.6313C20.3106 51.7765 20.5072 51.8581 20.7121 51.8581H20.7727C27.1206 51.2054 33.4975 50.8761 39.8788 50.8714C42.9091 50.8714 46.197 50.7499 49.3485 50.6133C49.4692 50.6094 49.588 50.5814 49.6978 50.531C49.8076 50.4806 49.9063 50.4089 49.9882 50.3198C50.07 50.2308 50.1333 50.1263 50.1743 50.0125C50.2154 49.8986 50.2334 49.7777 50.2273 49.6568C50.2313 49.5439 50.2129 49.4314 50.173 49.3257C50.1331 49.22 50.0726 49.1234 49.995 49.0414C49.9174 48.9594 49.8243 48.8938 49.7211 48.8483C49.6179 48.8028 49.5067 48.7783 49.3939 48.7764Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1041_411">
        <rect width="78" height="78" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const histoCollectionSvg = (
  <svg
    width="78"
    height="55"
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1041_411)">
      <path
        d="M77.9242 14.574C77.8182 10.8546 77.7121 6.64946 75.2121 3.68916C74.35 2.6483 73.278 1.80186 72.0664 1.20534C70.8548 0.608822 69.5309 0.275709 68.1818 0.227896C67.803 0.227896 67.4091 0.227896 66.9848 0.227896C62.303 0.0457239 57.5909 -0.0605469 52.9394 -0.0605469C46.4394 -0.0605469 39.8636 0.136814 33.4242 0.516339C28.4394 0.804778 22.5455 1.1843 16.6364 1.83708H16.2727C13.5606 2.12552 10.4848 2.45951 8.69696 4.69111C6.57575 7.33261 6.81817 11.2493 7.01514 14.5436C7.36057 19.2658 7.94212 23.9677 8.75758 28.6315C9.19697 31.2427 9.66665 33.8538 10.1364 36.4649C11.8142 44.6134 12.8979 52.8735 13.3788 61.1796L10.0151 61.2556C9.48483 61.2556 8.83333 61.2555 8.10605 61.1493C7.37878 61.043 6.19697 60.9975 5.22727 60.9975C2.74243 60.9975 1.28788 61.5136 0.68182 62.6522C-0.575756 64.9293 0.106052 69.9087 1.1212 72.201C3.33332 77.2563 8.96968 77.8939 13.6363 77.8939C14.9545 77.8939 16.2576 77.8939 17.4848 77.8028C18.7121 77.7118 19.5455 77.7118 20.5151 77.7118H23.7727C33.4394 77.7118 43.4697 77.7117 53.2424 76.6946C53.3209 76.6941 53.3984 76.6762 53.4691 76.642C53.5399 76.6079 53.6022 76.5584 53.6515 76.4973H53.9091C54.5221 76.4951 55.1344 76.4545 55.7424 76.3758C60.5 75.7838 63.5606 73.9013 64.8333 70.7588C66.5455 66.4778 65.6818 61.377 64.9242 56.8834L64.697 55.5323C64.2525 52.8604 63.7727 50.1481 63.2576 47.3953C61.4848 37.725 59.6515 27.66 60.2273 17.9897H63.1364H67.6061C70.8578 18.0211 74.1079 17.8284 77.3333 17.4128C77.5282 17.3624 77.7009 17.2485 77.8243 17.0892C77.9477 16.9298 78.0148 16.734 78.0151 16.5323C77.9697 16.0161 77.9394 15.3027 77.9242 14.574ZM74.3939 16.0921C73.3968 16.2923 72.3802 16.3789 71.3636 16.3501H68.4091C66.8182 16.3501 65.2273 16.3501 63.6363 16.3501H60.3636C60.5152 14.832 60.697 13.4354 60.9242 12.2057C62.1515 5.48055 64.5758 2.06478 68.1212 2.06478C68.6317 2.06469 69.1404 2.12589 69.6364 2.247C73.5303 3.15786 75.697 6.43692 76.0454 12.2664C76.0454 12.6459 76.0455 13.0103 76.1515 13.3291C76.2879 14.8168 76.3939 15.6062 74.3939 16.1528V16.0921ZM2.0909 67.9959C1.90908 64.9597 2.87878 63.6238 5.71211 63.2139C7.51943 62.9663 9.34271 62.8547 11.1667 62.8799H14.197H17.2273H18.4394L43.6364 62.3637C43.7765 66.1429 44.9907 69.8033 47.1363 72.9146C47.6882 73.7784 48.3976 74.5303 49.2273 75.131C43.4394 75.5712 37.1818 75.7838 29.0455 75.8293H23.9848H16.9848H15.0909C14.2879 75.8293 13.4697 75.8293 12.6364 75.8293C10.0299 76.0241 7.4269 75.4092 5.18182 74.0683C4.24547 73.3666 3.48062 72.4607 2.94514 71.4193C2.40965 70.3778 2.11754 69.2279 2.0909 68.0566V67.9959ZM45.4394 61.5136C45.4679 61.3397 45.4351 61.1613 45.3466 61.0089C45.2582 60.8566 45.1195 60.7398 44.9545 60.6787C44.8261 60.6197 44.6867 60.5887 44.5455 60.5876L15.2121 61.1948C14.7255 52.7612 13.6267 44.3743 11.9242 36.1006V35.6604C11.0909 31.1061 10.2273 26.3544 9.6212 21.6483C9.5303 20.9652 9.40908 20.1302 9.28787 19.356C8.66666 15.4241 7.89393 10.5358 9.28787 7.46926C11.0909 3.65883 16.197 3.43107 20.2879 3.2489C21.106 3.2489 21.8939 3.24891 22.6212 3.11228C27.7121 2.68721 32.4091 2.36843 36.9848 2.14072C42.0303 1.89782 47.2424 1.77639 52.4697 1.77639C56.0606 1.77639 59.7576 1.77637 63.4545 1.94336C60.5757 4.41786 59.5757 8.71408 58.9091 12.9951C58.1017 19.1705 58.1425 25.4276 59.0303 31.5919C59.5909 36.1462 60.3333 40.7005 61.0606 45.1485C61.303 46.6666 61.5606 48.1847 61.803 49.7028C62 50.9932 62.2424 52.2836 62.4697 53.5891C63.289 57.3979 63.7406 61.2768 63.8182 65.1722C63.8182 69.8176 62.303 72.4591 59.0758 73.7039C57.3664 74.387 55.5515 74.7672 53.7121 74.8274C52.8483 74.8444 51.9893 74.6949 51.1818 74.3871C47.4546 72.9905 45.0151 65.491 45.4394 61.5743V61.5136Z"
        fill="white"
      />
      <path
        d="M48.7424 13.9058C48.7408 13.7967 48.7167 13.6892 48.6715 13.5899C48.6264 13.4906 48.5611 13.4018 48.48 13.329C48.3988 13.2563 48.3035 13.2012 48.2 13.1672C48.0966 13.1332 47.9872 13.1211 47.8788 13.1316C37.803 14.1184 27.5606 14.6497 17.4545 14.6497C17.3353 14.6476 17.2168 14.6698 17.1064 14.715C16.996 14.7602 16.8959 14.8275 16.8123 14.9127C16.7286 14.9979 16.6632 15.0993 16.6199 15.2107C16.5767 15.3221 16.5565 15.4411 16.5606 15.5606C16.5543 15.6793 16.5726 15.798 16.6141 15.9093C16.6557 16.0207 16.7196 16.1222 16.8021 16.2077C16.8845 16.2931 16.9837 16.3606 17.0933 16.406C17.203 16.4514 17.3208 16.4737 17.4394 16.4714C27.5606 16.4714 37.803 15.9705 47.8939 14.9533C48.1448 14.9265 48.3749 14.8013 48.5339 14.605C48.6929 14.4087 48.7679 14.1573 48.7424 13.9058Z"
        fill="white"
      />
      <path
        d="M48.2121 25.6258C48.2184 25.5071 48.2002 25.3883 48.1586 25.277C48.1171 25.1657 48.0531 25.0641 47.9706 24.9786C47.8882 24.8932 47.789 24.8256 47.6794 24.7803C47.5697 24.7349 47.4519 24.7126 47.3333 24.7149C37.8366 24.6431 28.3501 25.354 18.9697 26.8402C18.7671 26.8631 18.5817 26.9654 18.454 27.1246C18.3263 27.2838 18.2666 27.4872 18.2879 27.6904C18.3065 27.9376 18.416 28.1691 18.5951 28.3401C18.7742 28.5112 19.0102 28.6096 19.2576 28.6164H19.4242C28.6555 27.1667 37.9897 26.4762 47.3333 26.5518C47.4533 26.5542 47.5724 26.5316 47.6832 26.4853C47.7939 26.439 47.8938 26.37 47.9765 26.2829C48.0592 26.1958 48.1228 26.0924 48.1634 25.9792C48.204 25.8661 48.2206 25.7457 48.2121 25.6258Z"
        fill="white"
      />
      <path
        d="M20.5758 39.896H20.7727C25.2911 39.2437 29.8451 38.8686 34.4091 38.7726H36.1364C37.3939 38.7726 38.6515 38.9396 39.8788 39.0611C41.3878 39.2393 42.9049 39.3406 44.4242 39.3647C46.0459 39.3874 47.6612 39.1569 49.2121 38.6815C49.4194 38.615 49.5953 38.475 49.7069 38.2877C49.8185 38.1004 49.8581 37.8788 49.8182 37.6644C49.7998 37.4575 49.7064 37.2644 49.5556 37.1218C49.4049 36.9791 49.2072 36.8967 49 36.8901C48.9046 36.8756 48.8075 36.8756 48.7121 36.8901C47.2374 37.3298 45.7052 37.5447 44.1667 37.5278C42.6515 37.5278 40.9848 37.3608 39.4242 37.209C37.8636 37.0572 36.3939 36.8902 34.8788 36.875H34.4849C29.9209 36.9734 25.3672 37.3485 20.8485 37.9984C20.5951 38.0325 20.3649 38.1641 20.2065 38.3653C20.0482 38.5664 19.9741 38.8213 20 39.0762C19.9802 39.2596 20.0277 39.444 20.1336 39.5949C20.2396 39.7457 20.3967 39.8528 20.5758 39.896Z"
        fill="white"
      />
      <path
        d="M49.3939 48.7764C46.2424 48.913 43.0303 48.9737 39.9394 49.0344C33.543 49.0395 27.151 49.3689 20.7879 50.0212C20.5373 50.0554 20.3095 50.1847 20.1516 50.3825C19.9936 50.5804 19.9176 50.8315 19.9394 51.0839C19.9394 51.2892 20.0208 51.4861 20.1657 51.6313C20.3106 51.7765 20.5072 51.8581 20.7121 51.8581H20.7727C27.1206 51.2054 33.4975 50.8761 39.8788 50.8714C42.9091 50.8714 46.197 50.7499 49.3485 50.6133C49.4692 50.6094 49.588 50.5814 49.6978 50.531C49.8076 50.4806 49.9063 50.4089 49.9882 50.3198C50.07 50.2308 50.1333 50.1263 50.1743 50.0125C50.2154 49.8986 50.2334 49.7777 50.2273 49.6568C50.2313 49.5439 50.2129 49.4314 50.173 49.3257C50.1331 49.22 50.0726 49.1234 49.995 49.0414C49.9174 48.9594 49.8243 48.8938 49.7211 48.8483C49.6179 48.8028 49.5067 48.7783 49.3939 48.7764Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1041_411">
        <rect width="78" height="78" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const defaultSvg = (
  <svg
    width="50"
    height="25"
    viewBox="0 0 132 132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M65.96 66.8799C66.14 67.6099 66.91 68.2799 67.9 68.0499L74.11 66.4999C74.97 66.2799 75.49 65.4199 75.28 64.5599C75.06 63.6999 74.2 63.1799 73.34 63.3899L67.13 64.9399C66.27 65.1599 65.75 66.0199 65.96 66.8799Z"
      fill="white"
    />
    <path
      d="M2.15002 131.76H27.76C28.64 131.76 29.36 131.04 29.36 130.16V2.12991C29.36 1.24991 28.64 0.529907 27.76 0.529907H2.15002C1.27002 0.529907 0.549988 1.24991 0.549988 2.12991V130.16C0.549988 131.04 1.27002 131.76 2.15002 131.76ZM3.75 3.72992H26.16V32.5399H8.56C7.68 32.5399 6.96002 33.2599 6.96002 34.1399C6.96002 35.0199 7.68 35.7399 8.56 35.7399H26.16V128.56H3.75V3.72992V3.72992Z"
      fill="white"
    />
    <path
      d="M130.18 13.3298H104.57C103.69 13.3298 102.97 14.0498 102.97 14.9298V130.16C102.97 131.04 103.69 131.76 104.57 131.76H130.18C131.06 131.76 131.78 131.04 131.78 130.16V14.9298C131.78 14.0498 131.06 13.3298 130.18 13.3298V13.3298ZM128.58 128.56H106.17V106.15H123.77C124.65 106.15 125.37 105.43 125.37 104.55C125.37 103.67 124.65 102.95 123.77 102.95H106.17V54.9398H123.77C124.65 54.9398 125.37 54.2198 125.37 53.3398C125.37 52.4598 124.65 51.7398 123.77 51.7398H106.17V48.5399H123.77C124.65 48.5399 125.37 47.8198 125.37 46.9398C125.37 46.0598 124.65 45.3398 123.77 45.3398H106.17V16.5298H128.58V128.56V128.56Z"
      fill="white"
    />
    <path
      d="M21.35 45.3298H8.54999C7.66999 45.3298 6.95001 46.0498 6.95001 46.9298C6.95001 47.8098 7.66999 48.5298 8.54999 48.5298H21.35C22.23 48.5298 22.95 47.8098 22.95 46.9298C22.95 46.0498 22.23 45.3298 21.35 45.3298Z"
      fill="white"
    />
    <path
      d="M21.35 51.7399H8.54999C7.66999 51.7399 6.95001 52.4599 6.95001 53.3399C6.95001 54.2199 7.66999 54.9399 8.54999 54.9399H21.35C22.23 54.9399 22.95 54.2199 22.95 53.3399C22.95 52.4599 22.23 51.7399 21.35 51.7399Z"
      fill="white"
    />
    <path
      d="M40.56 64.5399C39.68 64.5399 38.96 65.2599 38.96 66.1399V91.7499C38.96 92.6299 39.68 93.3499 40.56 93.3499C41.44 93.3499 42.16 92.6299 42.16 91.7499V66.1399C42.16 65.2599 41.44 64.5399 40.56 64.5399V64.5399Z"
      fill="white"
    />
    <path
      d="M46.96 64.5399C46.08 64.5399 45.36 65.2599 45.36 66.1399V91.7499C45.36 92.6299 46.08 93.3499 46.96 93.3499C47.84 93.3499 48.56 92.6299 48.56 91.7499V66.1399C48.56 65.2599 47.84 64.5399 46.96 64.5399V64.5399Z"
      fill="white"
    />
    <path
      d="M53.36 19.73H34.16C33.28 19.73 32.56 20.45 32.56 21.33V130.16C32.56 131.04 33.28 131.76 34.16 131.76H53.36C54.24 131.76 54.96 131.04 54.96 130.16V49.25L75.23 130.55C75.41 131.28 76.18 131.94 77.17 131.72L95.8 127.08C96.6 126.87 97.18 126.12 96.97 125.14L73.74 31.97C73.52 31.15 72.74 30.59 71.8 30.8L54.96 35V21.34C54.96 20.46 54.24 19.74 53.36 19.74V19.73ZM51.76 128.56H35.76V112.56H46.96C47.84 112.56 48.56 111.84 48.56 110.96C48.56 110.08 47.84 109.36 46.96 109.36H35.76V48.55H46.96C47.84 48.55 48.56 47.83 48.56 46.95C48.56 46.07 47.84 45.35 46.96 45.35H35.76V22.94H51.76V128.57V128.56ZM71.02 34.28L93.48 124.35L77.95 128.22L74.08 112.69L84.95 109.98C85.81 109.76 86.33 108.9 86.12 108.04C85.9 107.18 85.04 106.67 84.18 106.87L73.31 109.58L60.15 56.78L71.02 54.07C71.88 53.85 72.4 52.99 72.19 52.13C71.98 51.27 71.11 50.75 70.25 50.96L59.38 53.67L55.51 38.14L71.04 34.27L71.02 34.28Z"
      fill="white"
    />
  </svg>
);
